import React from "react";
import { Search } from "lucide-react";

/**
 * Reusable SearchBar component with icon
 * @param {Object} props
 * @param {string} props.value - Search value
 * @param {Function} props.onChange - Change handler
 * @param {string} props.placeholder - Placeholder text
 * @param {string} props.className - Additional classes
 */
export default function SearchBar({
  value,
  onChange,
  placeholder = "Cari...",
  className = "",
}) {
  return (
    <div className={`relative ${className}`}>
      <Search className="absolute left-3 top-2.5 text-gray-400" size={18} />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className="w-full pl-10 pr-3 py-2 border rounded-lg bg-white shadow-sm focus:ring-2 focus:ring-blue-400 outline-none text-sm"
      />
    </div>
  );
}
